import { render, staticRenderFns } from "./CaseUploadsList.vue?vue&type=template&id=b65b506e"
import script from "./CaseUploadsList.vue?vue&type=script&lang=js"
export * from "./CaseUploadsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports